// src/store/modules/device.js
import { getLandingWidth } from '@/config/screen-sizes.js'

function readViewport() {
  // visualViewport лучше в некоторых мобильных/zoom ситуациях
  if (typeof window !== 'undefined' && window.visualViewport) {
    return {
      width: Math.round(window.visualViewport.width),
      height: Math.round(window.visualViewport.height)
    }
  }
  // fallback
  return {
    width: Math.round(document.documentElement.clientWidth || window.innerWidth || 0),
    height: Math.round(document.documentElement.clientHeight || window.innerHeight || 0)
  }
}

export default {
  namespaced: true,
  state: () => {
    const { width, height } = readViewport()
    return {
      width,
      height,
      isMobile: width <= 768,
      orientation: width > height ? 'landscape' : 'portrait',
      // internal flag to avoid multiple addEventListener calls
      _resizeAttached: false
    }
  },
  mutations: {
    SET_DIMENSIONS(state, { width, height }) {
      state.width = width
      state.height = height
      state.isMobile = width <= 768
      state.orientation = width > height ? 'landscape' : 'portrait'
    },
    SET_RESIZE_ATTACHED(state, v) {
      state._resizeAttached = !!v
    }
  },
  actions: {
    updateDevice({ commit, dispatch }) {
      const { width, height } = readViewport()
      commit('SET_DIMENSIONS', { width, height })

      // landing_settings.size: { width, height }
      const landingWidth = getLandingWidth(width)
      // dispatch to landing module to update settings.size (root)
      dispatch('landing/UPDATE_LANDING_SETTINGS', {
        size: { width: landingWidth, height }
      }, { root: true })
    },
    // attach resize only once
    watchResize({ state, commit, dispatch }) {
      if (state._resizeAttached) return
      const handler = () => {
        // debounce-ish: use requestAnimationFrame to batch rapid resizes
        if (typeof window !== 'undefined') {
          window.requestAnimationFrame(() => dispatch('updateDevice'))
        }
      }
      window.addEventListener('resize', handler)
      // also listen visualViewport resize/scroll (for better mobile behavior)
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', handler)
        window.visualViewport.addEventListener('scroll', handler)
      }
      commit('SET_RESIZE_ATTACHED', true)
      // immediately sync once
      dispatch('updateDevice')
    }
  },
  getters: {
    deviceInfo: (state) => ({
      width: state.width,
      height: state.height,
      isMobile: state.isMobile,
      orientation: state.orientation,
    }),
    isMobile: (state) => state.isMobile,
    orientation: (state) => state.orientation,
  }
}
